module.exports = __webpack_public_path__ + "static/406-c4aba5ccdffa0db0a830d5956ba2c75f.png";